import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const ChevronDown = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="chevron down icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.58579 6.56778C3.36683 5.78673 4.63317 5.78673 5.41421 6.56778L12 13.1536L18.5858 6.56778C19.3668 5.78673 20.6332 5.78673 21.4142 6.56778C22.1953 7.34883 22.1953 8.61516 21.4142 9.39621L12 18.8104L2.58579 9.39621C1.80474 8.61516 1.80474 7.34883 2.58579 6.56778Z"
    />
  </svg>
)
